import React, { FunctionComponent, useState, useEffect } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { T } from 'services/lang/LanguageService';
import { Chips } from 'primereact/chips';
import { DashboardEditorProps } from '../../ComponentType';

type AlertFanEditorProps = {
    itemsPerPage?: number;
    updateFrequency?: number;
    topicTags?: string[];
    itemTags?: string[];
};

const defaultAlertFanConfig: AlertFanEditorProps = {
    itemsPerPage: undefined,
    updateFrequency: undefined,
    topicTags: undefined,
    itemTags: undefined
};

function AlertFanEditor({ config, onConfigChange }: DashboardEditorProps<AlertFanEditorProps>) {
    let conf = config ?? defaultAlertFanConfig;

    if (Object.keys(conf).length === 0) {
        conf = defaultAlertFanConfig;
    }

    const [currentConfig, setCurrentConfig] = useState(conf);

    useEffect(() => {
        onConfigChange(currentConfig);
    }, [currentConfig]);

    const setConfigPropertyState = (property: keyof AlertFanEditorProps, value: any) => {
        setCurrentConfig((prevState) => ({ ...prevState, [property]: value }));
    };

    const handleConfigChange = (e: any): void => {
        setConfigPropertyState(e.target.id as keyof AlertFanEditorProps, e.value);
    };

    return (
        <div className="grid">
            <div className={` col-6 flex flex-column gap-2`}>
                <label htmlFor='itemsPerPage'>{T("component.items-per-page")}</label>
                <InputNumber id='itemsPerPage' value={conf.itemsPerPage} onValueChange={handleConfigChange} />
            </div>
            <div className="col-6 flex flex-column gap-2">
                <label htmlFor='updateFrequency'>{T("load-conf.update-frequency")}</label>
                <InputNumber id='updateFrequency' value={conf.updateFrequency} onValueChange={handleConfigChange} />
            </div>
            <div className="col-6 flex flex-column gap-2">
                <label htmlFor='topicTags'>{T("word.topic-tags")}</label>
                <Chips id='topicTags' value={conf.topicTags} onChange={handleConfigChange} />
            </div>
            <div className="col-6 flex flex-column gap-2">
                <label htmlFor='itemTags'>{T("word.item-tags")}</label>
                <Chips id='itemTags' value={conf.itemTags} onChange={handleConfigChange} />
            </div>
        </div>
    );
}

export default AlertFanEditor as FunctionComponent;
